/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
/*<Image1 align="left" width="45%" />*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    img: "img"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "This is an alien mushm gardn that takes real time to grow. If the gardn is open it will grow twice as fast, but be patient. It could be a few hours before you start to see growth either way. As soon as you first open the gardn it will begin, so feel free to come back the next day and see how it's doing!"), "\n", React.createElement(_components.p, null, React.createElement(_components.a, {
    href: "https://jerrytron.itch.io/mushm-gardn"
  }, "Download Mushm Gardn on itch.io!")), "\n", React.createElement(_components.img, {
    src: "mushm-gardn-01.gif",
    alt: "alien mushroom garden"
  }), "\n", "\n", "\n", React.createElement(_components.img, {
    src: "mushm-gardn-02.gif",
    alt: "alien mushroom garden"
  }), "\n");
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
